import { useEffect, useState } from "react";
import { addPackagesForm, updatePackagesForm } from "../../lib/actions";
import DropDown from "../../components/GDropDownList/DropDown";
import { useNavigate } from "react-router-dom";
import DropDownFilterPaginations from "../../components/GDropDownList/DropDownFilterPaginations";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";

export default function EditPackagesUi({packagesData, shapOfPackags, categoriesData, TopResultOfPackags, positionOfPackags, search }) {

    const nav = useNavigate();
    const [selectedValues, setSelectedValues] = useState({position : null, topResult : null, categoryId : null, adShape: null});
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    useEffect(() => {
        setSelectedValues((prev)=>({
            ...prev, 
            position : packagesData.position,
            topResult : packagesData.topResult == true ? "1" : "0",
            categoryId : packagesData.sub_category_id,
            adShape : packagesData.ad_shape,
        }))
        search(packagesData.sub_category_name);
    }, [packagesData])

    const onChange = (e, paramkey) => {
        setSelectedValues(prev => ({
            ...prev,
            [paramkey]: e
        }));
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const result = await updatePackagesForm(packagesData.id, new FormData(e.target), navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    if ((packagesData).length < 1) {
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "name in arabic" : "الاسم باللغة العربية "} </label>
                    <input
                        type="text"
                        defaultValue={packagesData?.title?.ar}
                        name="title_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in arabic" : "أدخل الاسم باللغة العربية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "name in english" : "الاسم باللغة الانجيليزية "}</label>
                    <input
                        type="text"
                        defaultValue={packagesData?.title?.en}
                        name="title_en"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in english" : " أدخل الاسم باللغة الانجليزية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "description in arabic" : "الوصف باللغة العربية "} </label>
                    <input
                        type="text"
                        defaultValue={packagesData?.description?.ar}
                        name="description_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter description in arabic" : "أدخل الوصف باللغة العربية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "description in english" : "الوصف باللغة الانجليزية "} </label>
                    <input
                        type="text"
                        name="description_en"
                        defaultValue={packagesData?.description?.en}
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter description in english" : "أدخل الوصف باللغة الانجليزية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "category" : "الفئة"}</label>
                    <DropDownFilterPaginations search={search} options={categoriesData} value={selectedValues?.categoryId} onchange={(e)=>onChange(e, "categoryId")} defaultText={currentLang === "en" ? "Select the category" : "أختر الفئة (اختياري) "} paramkey="sub_category_id" />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "ad shape" : "شكل الإعلان"}</label>
                    <DropDown options={shapOfPackags} value={selectedValues?.adShape} onchange={(e)=>onChange(e, "adShape")} defaultText={currentLang === "en" ? "Select the ad shape" : "أختر شكل الإعلان "} paramkey="ad_shape" />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "package price" : "سعر الباقة"} </label>
                    <input
                        type="number"
                        defaultValue={packagesData.price}
                        name="price"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter package price" : "أدخل سعر الباقة "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "place of appearance" : "مكان الظهور"}</label>
                    <DropDown options={positionOfPackags} value={selectedValues.position} defaultText={currentLang === "en" ? "enter place of appearance" : "ادخل مكان الظهور"} paramkey="position" onchange={(e)=>onChange(e, "position")} />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "order of appearance" : "ترتيب الظهور"}</label>
                    <DropDown options={TopResultOfPackags} value={selectedValues.topResult} defaultText={currentLang === "en" ? "enter order of appearance" : "ادخل ترتيب الظهور"} paramkey="topResult" onchange={(e)=>onChange(e, "topResult")} />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "package duration" : "مدة الباقة"} </label>
                    <input
                        type="number"
                        name="duration"
                        defaultValue={packagesData?.duration}
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter package duration" : "أدخل مدة الباقة  "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? " number of photo duration" : "عدد الصور"} </label>
                    <input
                        type="number"
                        name="number_of_photo"
                        defaultValue={packagesData?.number_of_photo}
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter number of photo" : "أدخل عدد الصور"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "Priority" : "ترتيب الأهمية"} </label>
                    <input
                        type="number"
                        name="priority"
                        defaultValue={packagesData?.priority}
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        placeholder={currentLang === "en" ? "enter priority" : "أدخل ترتيب الأهمية"}
                    />
                </div>
            </div>
            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};